import fetchAPI from '../../../lib/utils/fetch-api'

export const configuredApiOrigin = String(process.env.REACT_APP_SVETOFOR_DASHBOARD_PUBLIC_API_ORIGIN || '').replace(/\/+$/, '')

export const fetchDashboardAPI = (path: string, options?: Parameters<typeof fetchAPI>[1], localError = false) => fetchAPI(`${configuredApiOrigin}${path}`, options, localError)

export type DashboardCatalogGroup = { id: number; name: string; indicators: Array<{ id: number; name: string }> }
export type DashboardGroupGrant = { groupId: number; all: boolean; indicatorIds: number[] }
